import React, { useEffect, useState } from "react";
import { ptBR } from "date-fns/locale";
import { RootStateOrAny, useSelector } from "react-redux";
import moment from "moment";
import { BeatLoader } from "react-spinners";
import * as Styles from "../../styles";
import MaterialUI from "../../../../material-UI";
import * as SVGIcons from "../../../../assets/iconsSVG";
import { useListarProfissoes } from "../../../../services/api/DadosComum/profissoes";
import { useListarEstadosCivis } from "../../../../services/api/DadosComum/estados-civis";
import { useListarRendasFamiliares } from "../../../../services/api/DadosComum/rendas-familiares";
import { useListarSexos } from "../../../../services/api/DadosComum/sexos";
import { useListarObjetivosCompras } from "../../../../services/api/Mobile_ObjetivosCompras/objetivos-compras";
import { useBuscaCep } from "../../../../services/api/DadosComum/buscaCep";
import { AuthState } from "../../../../store/ducks/auth/types";
import { useAlterarDadosComplementares } from "../../../../services/api/AppWeb_Lead/alterar-dados-complementares";

export interface LeadDadosCompInterface {
  idLeadCorretor: string;
  idLead: string;
  dataNascimento: string;
  idProfissao: string;
  profissao: string;
  idEstadoCivil: string;
  estadoCivil: string;
  idRendaFamiliar: string;
  rendaFamiliar: string;
  idSexo: string;
  sexo: string;
  idObjetivoCompra: string;
  objetivoCompra: string;
  cep: string;
  cidade: string;
  bairro: string;
}
interface Props {
  data: LeadDadosCompInterface | undefined;
  closeModal: () => void;
  readOnly?: boolean;
}

const dadosComplementaresForm: React.FC<Props> = (props) => {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isDisabled = props.readOnly === true;
  const { data: dataProfissoes, refetch: refectchDataProfissoes } =
    useListarProfissoes();
  const [profissao, setProfissao] = useState<any>(
    props?.data?.idProfissao
      ? { id: props?.data?.idProfissao, nome: props?.data?.profissao }
      : null
  );
  const { data: dataEstadosCivis } = useListarEstadosCivis();
  const [estadoCivil, setEstadoCivil] = useState<any>(
    props?.data?.idEstadoCivil
      ? { id: props?.data?.idEstadoCivil, nome: props?.data?.estadoCivil }
      : null
  );
  const { data: dataRendasFamiliares } = useListarRendasFamiliares();
  const [rendaFamiliar, setRendaFamiliar] = useState<any>(
    props?.data?.idRendaFamiliar
      ? { id: props?.data?.idRendaFamiliar, nome: props?.data?.rendaFamiliar }
      : null
  );
  const { data: dataSexos } = useListarSexos();
  const [sexo, setSexo] = useState<any>(
    props?.data?.idSexo
      ? { id: props?.data?.idSexo, nome: props?.data?.sexo }
      : null
  );
  const { data: dataObjetivosCompras, refetch: refetchdataObjetivosCompras } =
    useListarObjetivosCompras();
  const [objetivoCompra, setObjetivoCompra] = useState<any>(
    props?.data?.idObjetivoCompra
      ? { id: props?.data?.idObjetivoCompra, nome: props?.data?.objetivoCompra }
      : null
  );

  const [cep, setCep] = useState(
    props?.data?.cep
      ? `${props?.data?.cep.slice(0, 5)}-${props?.data?.cep.slice(5)}`
      : ""
  );
  const { data: dataBuscaCep, refetch: refetchCep } = useBuscaCep(cep);
  const [cidade, setCidade] = useState(
    props?.data?.cidade ? props?.data?.cidade : ""
  );
  const [bairro, setBairro] = useState(props?.data?.bairro ?? "");
  const [dataNascimento, setDataNascimento] = useState<any>(
    props?.data?.dataNascimento
      ? moment(props?.data?.dataNascimento, "DD/MM/YYYY")
      : null
  );

  const mascararCEP = (e: any) => {
    const inputValue = e.target.value;
    const formattedCep = inputValue.replace(/[^0-9]/g, "").slice(0, 8);

    if (formattedCep.length <= 5) {
      setCep(formattedCep);
    } else if (formattedCep.length > 5) {
      setCep(`${formattedCep.slice(0, 5)}-${formattedCep.slice(5)}`);
    }
  };

  useEffect(() => {}, [dataNascimento]);
  useEffect(() => {
    refectchDataProfissoes();
    refetchdataObjetivosCompras();
  }, []);

  useEffect(() => {
    if (cep.length === 9) {
      refetchCep();
    }
  }, [cep]);

  useEffect(() => {
    if (dataBuscaCep) {
      setBairro(dataBuscaCep?.data?.bairro);
      setCidade(dataBuscaCep?.data?.localidade);
    }
  }, [dataBuscaCep]);

  const handleSubmit = () => {
    mutate();
  };

  const { mutate, isLoading, isSuccess } = useAlterarDadosComplementares({
    idLeadCorretor: props?.data?.idLeadCorretor
      ? props?.data?.idLeadCorretor
      : null,
    body: {
      idLead: props?.data?.idLead ? props?.data?.idLead : null,
      dataNascimento: dataNascimento
        ? moment(dataNascimento).format("YYYY-MM-DD")
        : null,
      idProfissao: profissao?.id,
      idEstadoCivil: estadoCivil?.id,
      idRendaFamiliar: rendaFamiliar?.id,
      idSexo: sexo?.id,
      idObjetivoCompra: objetivoCompra?.id,
      cep,
      cidade,
      bairro,
      cpf: null,
      logradouro: null,
      observacoes: null,
      complementoEndereco: null,
    },
  });

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
    }
  }, [isSuccess]);

  return (
    <>
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Data de Nascimento</Styles.LabelText>
          <Styles.LocalizationProvider
            locale={ptBR}
            dateAdapter={MaterialUI.AdapterDateFns}
          >
            <Styles.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={dataNascimento}
              disabled={isDisabled}
              components={{
                OpenPickerIcon: SVGIcons.CalendarIcon,
              }}
              maxDate={new Date()}
              InputAdornmentProps={{ position: "start" }}
              onChange={(newValue: any) => setDataNascimento(newValue)}
              renderInput={(params: any) => (
                <>
                  <Styles.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Data *"
                    fullWidth
                  />
                </>
              )}
            />
          </Styles.LocalizationProvider>
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Profissão</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={{
              nome: "Selecione uma profissão",
              id: "1",
            }}
            fullWidth
            disabled={isDisabled}
            options={dataProfissoes?.data ? dataProfissoes?.data : []}
            value={profissao}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option.nome}
            getOptionLabel={(option: any) => option.nome || ""}
            // @ts-ignore
            onChange={(event: any, newValue: string | null) => {
              setProfissao(newValue);
            }}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Estado Cívil</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={{
              nome: "Selecione um estado cívil",
              id: "1",
            }}
            fullWidth
            disabled={isDisabled}
            options={dataEstadosCivis?.data ? dataEstadosCivis?.data : []}
            value={estadoCivil}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{
                    shrink: false,
                    flex: "0 0 calc(33.33% - 10px)",
                  }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option.nome}
            getOptionLabel={(option: any) => option.nome || ""}
            // @ts-ignore
            onChange={(event: any, newValue: string | null) => {
              setEstadoCivil(newValue);
            }}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Renda familiar</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={{
              nome: "Selecione uma renda familiar",
              id: "1",
            }}
            fullWidth
            disabled={isDisabled}
            options={dataRendasFamiliares ? dataRendasFamiliares?.data : []}
            value={rendaFamiliar}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{
                    shrink: false,
                    flex: "0 0 calc(33.33% - 10px)",
                  }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option.nome}
            getOptionLabel={(option: any) => option.nome || ""}
            // @ts-ignore
            onChange={(event: any, newValue: string | null) => {
              setRendaFamiliar(newValue);
            }}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Sexo</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={{
              nome: "Selecione um sexo",
              id: "1",
            }}
            fullWidth
            disabled={isDisabled}
            options={dataSexos ? dataSexos?.data : []}
            value={sexo}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option.nome}
            getOptionLabel={(option: any) => option.nome || ""}
            // @ts-ignore
            onChange={(event: any, newValue: string | null) => {
              setSexo(newValue);
            }}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Objetivo de compra</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            defaultValue={{
              nome: "Selecione um objetivo de compra",
              id: "1",
            }}
            fullWidth
            disabled={isDisabled}
            options={dataObjetivosCompras ? dataObjetivosCompras?.data : []}
            value={objetivoCompra}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{
                    shrink: false,
                    flex: "0 0 calc(33.33% - 10px)",
                  }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option.nome}
            getOptionLabel={(option: any) => option.nome || ""}
            // @ts-ignore
            onChange={(event: any, newValue: string | null) => {
              setObjetivoCompra(newValue);
            }}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>CEP</Styles.LabelText>
          <Styles.TextField
            size="small"
            InputLabelProps={{ shrink: false }}
            variant="outlined"
            label="Data *"
            fullWidth
            disabled={isDisabled}
            placeholder="Insira um CEP"
            onChange={(e: any) => mascararCEP(e)}
            value={cep}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Cidade</Styles.LabelText>
          <Styles.TextField
            size="small"
            InputLabelProps={{ shrink: false }}
            variant="outlined"
            label="Data *"
            fullWidth
            disabled={isDisabled}
            onChange={(e: any) => setCidade(e.target.value)}
            value={cidade}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Bairro</Styles.LabelText>
          <Styles.TextField
            size="small"
            InputLabelProps={{ shrink: false }}
            variant="outlined"
            label="Data *"
            fullWidth
            disabled={isDisabled}
            onChange={(e: any) => setBairro(e.target.value)}
            value={bairro}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.FooterDialog>
        <Styles.Button
          style={{ width: "100%" }}
          variant="outlined"
          onClick={() => {
            props.closeModal();
          }}
        >
          Fechar
        </Styles.Button>
        {isCorretor && !isDisabled ? (
          <Styles.SaveButton
            onClick={() => handleSubmit()}
            style={{
              width: "100%",
              background: "#4a76fb",
              boxShadow: "none",
              color: "#fff !important",
            }}
          >
            {isLoading ? <BeatLoader color="#fff" size={10} /> : "Salvar"}
          </Styles.SaveButton>
        ) : null}
      </Styles.FooterDialog>
    </>
  );
};

export default dadosComplementaresForm;
